// extracted by mini-css-extract-plugin
export default {"page":"NotFound_page__CucGl","links":"NotFound_links__vQQJm","buttons":"NotFound_buttons__dYp+p"};